export const riskReviewKeys = {
  all: ["risk-review"],
  dashboard: () => [...riskReviewKeys.all, "dashboard"],
  requests: () => [...riskReviewKeys.all, "requests"],
  requestList: (filters) => [...riskReviewKeys.requests(), "list", filters],
  request: (id) => [...riskReviewKeys.requests(), "detail", id],
  approvals: (filters) => [...riskReviewKeys.all, "approvals", filters],
  templates: () => [...riskReviewKeys.all, "templates"],
  templateList: (filters) => [...riskReviewKeys.templates(), "list", filters],
  template: (id) => [...riskReviewKeys.templates(), id],
};
